import { useListType } from 'Stores/ListStore/ListStore';
import type { ListType } from 'Types/listType';
import type { Nullable } from 'Types/utils';
import { LIST_TYPES } from 'Utilities/consts';
import useSaleTimes from 'Utilities/hooks/useSaleTimes';

import useFeatureToggle, { FEATURES } from '../useFeatureToggle';

interface UseAdjustedListTypeProps {
	forceFormatBasedOnTime?: boolean;
}

export const useAdjustedListType = ({
	forceFormatBasedOnTime = false,
}: UseAdjustedListTypeProps = {}): Nullable<ListType> => {
	const listType = useListType();
	const { hasReceivedSaleTimes, isSaleActive } = useSaleTimes();
	const isRemoveBuyItNowFeatureEnabled = useFeatureToggle(FEATURES.removeBuyItNow);

	if (isRemoveBuyItNowFeatureEnabled) {
		return LIST_TYPES.auction;
	}

	const listTypeBasedOnSaleTime = isSaleActive ? LIST_TYPES.auction : LIST_TYPES.buyItNow;

	if (!hasReceivedSaleTimes) {
		return null;
	}

	if (forceFormatBasedOnTime) {
		return listTypeBasedOnSaleTime;
	}

	return listType || listTypeBasedOnSaleTime;
};
